// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__0bog0","logoImg":"App_logoImg__keGTY","appPageContainer":"App_appPageContainer__kmnhz"};